module.exports = __webpack_public_path__ + "static/questions-3405881a8c364c0b64714dc8ce65e601.gif";